import {VersionVariants} from '@jobseeker/lotus/enums';

import type {CTAProps} from './type';

import V1 from './V1';
import V2 from './V2';
import V3 from './V3';
import V4 from './V4';
import V5 from './V5';
import V6 from './V6';

const componentMap: any = {};
componentMap[VersionVariants.VERSION_ONE] = V1;
componentMap[VersionVariants.VERSION_TWO] = V2;
componentMap[VersionVariants.VERSION_THREE] = V3;
componentMap[VersionVariants.VERSION_FOUR] = V4;
componentMap[VersionVariants.VERSION_FIVE] = V5;
componentMap[VersionVariants.VERSION_SIX] = V6;

const CTA = (props: CTAProps) => {
  let Component;
  if (Object.keys(componentMap).includes(props.variant)) {
    Component = componentMap[props.variant];
  } else {
    Component = componentMap[VersionVariants.VERSION_ONE];
  }
  return (
    <Component data-testid={`CTA_${props.variant}_container`} {...props} />
  );
};

export default CTA;
